import { useState, createContext, useEffect } from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import Homepage from './components/Homepage';
import Dashboard from './components/Dashboard';
import BNBRide from './artifacts/contracts/BNBRide.sol/RideBNB2.json'
import Royalty from './artifacts/contracts/Royalty.sol/Royalty.json'
import Fee from './artifacts/contracts/Fee.sol/Fee.json'
import { message, Modal, Button, Spin } from 'antd';
import { ethers } from 'ethers';
import Teams from './components/Teams';
import BinaryTree from './components/BinaryTree';
import Admin from './components/Admin';
import Red from './components/Red';
import Downline from './components/Downline'
import Virtus from './components/Virtus';
import { TailSpin } from 'react-loader-spinner';
import { useTimer } from 'react-timer-hook';
import Rewards from './components/Rewards';

const AppState = createContext();

function MyTimer({ expiryTimestamp }) {
  const {
    seconds,
    minutes,
    hours,
    days
  } = useTimer({ expiryTimestamp});

  return <p><span>{days > 0 ? `${days.toString()} Days -` : null} {hours.toString().padStart(2, '0')}</span>:<span>{minutes.toString().padStart(2, '0')}</span>:<span>{seconds.toString().padStart(2, '0')}</span></p>
}

const erc20Abi = [
  "function balanceOf(address) view returns (uint256)",
  "function totalSupply() view returns (uint256)",
  "function transfer(address, uint256) returns (bool)",
  "function allowance(address owner, address spender) view returns (uint256)",
  "function approve(address, uint256) returns (bool)",
  "function transferFrom(address, address, uint256) returns (bool)",
];

// Public BSC mainnet RPC used for all read-only calls when no wallet is connected.
// Swap this for your own node / Ankr / QuickNode endpoint for better reliability.
const BSC_RPC = "https://opbnb-rpc.publicnode.com";

function App() {
  const {ethereum} = window;
  const navigate = useNavigate();
  const [theme, setTheme] = useState('dark');
  const [change, setChange] = useState(0);
  const [walletAddress, setWalletAddress] = useState("");
  const [id, setId] = useState("0");
  const [bal, setBal] = useState(0);
  const [bal2, setBal2] = useState(0);
  const [bal3, setBal3] = useState(0);
  const [shown, setShown] = useState(false);
  const [loaded, setLoaded] = useState(false);

  const ranks = ["Beginner", "Influencer", "Achiever", "Ambassador", "Pioneer", "Mentor", "Champion", "Director", "Titan", "Icon", "Legend", "Emperor", "Conqueror", "Chancellor", "Creator"];
  const contractAddress = "0xe69D7918Ce5a56647ef482e5F7762287e887bc57";
  const feeAddress = "0xAb267B65e39ec3C62c2B81AfD700c65D76A0F3f9";
  const royaltyAddress = "0xE3B75E8a3D32F1994c744F67F45eeF2E31029FAd";
  // const usdt = "0xbaC2e6b6d70d68F2F470856125Ed0658251A2F0c";
  const usdt = "0x9e5AAC1Ba1a2e6aEd6b32689DFcF62A509Ca96f3";
  const [levels, setLevels] = useState([0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]);
  const [percent, setPercent] = useState([0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]);

  // Stable read-only provider — always points at a real BSC RPC, never localhost,
  // so contract reads work whether or not a wallet is connected.
  const readProvider = new ethers.JsonRpcProvider(BSC_RPC);

  let provider;
  let signer;

  async function getProvider() {
    if (ethereum == null) {
      // No injected wallet — use the public read provider instead of
      // ethers' default JsonRpcProvider(), which points at localhost:8545
      // and returns "0x" (BAD_DATA) for every call since nothing is running there.
      provider = readProvider;
    } else {
      provider = new ethers.BrowserProvider(window.ethereum);
      signer = await provider.getSigner();
      let _bal = await provider.getBalance(walletAddress);
      let _bal2 = await provider.getBalance(feeAddress);
      let _bal3 = await provider.getBalance(royaltyAddress);
      setBal(convert(_bal));
      setBal2(convert(_bal2));
      setBal3(convert(_bal3));
    }
  }
  getProvider();

  async function getContract() {
    let provider = new ethers.BrowserProvider(window.ethereum);
    let signer = await provider.getSigner();
    return new ethers.Contract(contractAddress, BNBRide.abi, signer);
  }

  async function getFeeContract() {
    let provider = new ethers.BrowserProvider(window.ethereum);
    let signer = await provider.getSigner();
    return new ethers.Contract(feeAddress, Fee.abi, signer);
  }

  async function getRoyaltyContract() {
    let provider = new ethers.BrowserProvider(window.ethereum);
    let signer = await provider.getSigner();
    return new ethers.Contract(royaltyAddress, Royalty.abi, signer);
  }

  async function getUsdtContract() {
    let provider = new ethers.BrowserProvider(window.ethereum);
    let signer = await provider.getSigner();
    return new ethers.Contract(usdt, erc20Abi, signer);
  }

  // These now always read via readProvider (real BSC RPC) instead of the
  // possibly-undefined `provider` variable, so they work with or without a wallet.
  const staticContract = new ethers.Contract(contractAddress, BNBRide.abi, readProvider);
  const staticFeeContract = new ethers.Contract(feeAddress, Fee.abi, readProvider);
  const staticUsdtContract = new ethers.Contract(usdt, erc20Abi, readProvider);

  useEffect(() => {
    let _theme = localStorage.getItem('theme');
    if(_theme !== null) {
      setTheme(_theme);
    }

    async function getWallet() {
      if (ethereum == null) {
        // No wallet installed — don't attempt eth_requestAccounts, just skip silently.
        return;
      }
      try {
        const accounts = await ethereum.request({
          method: "eth_requestAccounts",
        });

        setWalletAddress(accounts[0]);
      } catch (error) {
        message.error("Install Web3 Wallet");
      }
    }

    getWallet();
  },[])

  useEffect(() => {
    // showModal();
    async function getLevels() {
      setLoaded(false);
      try {
        let _lvl = await staticContract.getLevels();
        setLevels([0])

        for(let i=0; i<_lvl[0].length; i++) {
          setLevels((prev) => [...prev, Number(ethers.formatEther(_lvl[0][i]))]);
        }
        setPercent([0]);
        for(let i=0; i<_lvl[1].length; i++) {
          setPercent((prev) => [...prev, Number(_lvl[1][i])/100]);
        }

        // Only look up an on-chain id if we actually have a connected, valid address.
        // Calling id("") or id(undefined) with no wallet is what caused the
        // "could not decode result data (0x)" errors.
        if (walletAddress && ethers.isAddress(walletAddress)) {
          let _id = await staticContract.id(walletAddress);
          setId(Number(_id));
        } else {
          setId(0);
        }
      } catch (err) {
        console.error("getLevels/id lookup failed:", err);
        setId(0);
      } finally {
        setLoaded(true);
      }
    }
    getLevels();
  },[walletAddress, change])

  const toggle = () => {
    if(theme === 'dark') {
      setTheme('light');
      localStorage.setItem('theme', 'light');
      } else if(theme === 'light') {
        setTheme('dark');
        localStorage.setItem('theme', 'dark');
    }
  }

  const Login = async () => {
    if (ethereum == null) {
      message.error("Install Web3 Wallet");
      return;
    }
    try {
      const accounts = await ethereum.request({
        method: "eth_requestAccounts",
      });

      setWalletAddress(accounts[0]);

      let id = await staticContract.id(accounts[0])
      let zeroAddr = 0;
      if(Number(id) == zeroAddr) {
        message.error("User Not Registered");
      } else {
        message.success("Logged In");
        navigate('/dashboard');
      }
    } catch (error) {
      message.error("Install Web3 Wallet");
    }
  }

  const formatTime = (time) => {
    const sec = Math.floor((time / 1000) % 60);
    const min = Math.floor((time / 60000) % 60);
    const hr = Math.floor((time / 3600000) % 24);
    const days = Math.floor(time / 86400000);
      return (
        `${days.toString().padStart(2, '0')} Days, ` +
        `${hr.toString().padStart(2, '0')} : ` +
        `${min.toString().padStart(2, '0')} : ` +
        `${sec.toString().padStart(2, '0')}`
      );
  };

  if (window.ethereum !== undefined) {
    ethereum.on("accountsChanged", (accounts) => {
      setWalletAddress(accounts[0]);
    });
  }

  const convert = (val) => {
    return Number(ethers.formatEther(val));
  }

  function getUTCTime(ms) {
    const now = new Date(ms);

    const year = now.getUTCFullYear();
    const month = now.getUTCMonth() + 1; // Months are zero-indexed
    const day = now.getUTCDate();
    const hours = now.getUTCHours();
    const minutes = now.getUTCMinutes();
    const seconds = now.getUTCSeconds();

    const utcTime = `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')} ${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')} UTC`;
    return utcTime;
  }

  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false); // State to manage loading animation

  const showModal = () => {
    setVisible(true);
    setLoading(true); // Start loading animation when modal opens
    setTimeout(() => {
      setLoading(false); // Stop loading animation after 3 seconds (simulating a loading process)
    }, 3000);
  };

  const handleOk = () => {
    setVisible(false);
  };

  const handleCancel = () => {
    setVisible(false);
  };

  return (
    <AppState.Provider value={{getRoyaltyContract, staticUsdtContract, getUsdtContract, formatTime,getUTCTime, staticFeeContract, getFeeContract, loaded, shown, setShown, feeAddress, royaltyAddress, bal, bal2, bal3, id, navigate, percent, levels, ranks, toggle, getContract, theme, Login, walletAddress, setWalletAddress, setId, change, setChange, staticContract, convert, contractAddress}}>
    <body className={theme}>
      <div className="App">
      <Modal
        open={visible}
        title="RainBNB Launching Soon!"
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
        className="rounded-lg shadow-xl"
      >
        <div className="text-center">
          {loading ? (
            <Spin size="large" className="my-4" /> // Show loading animation
          ) : (
            <>
              <p className="text-xl font-semibold text-gray-800">
                RainBNB is launching very soon! Get ready for a new era of financial freedom.
              </p>
              <p className="mt-4 text-gray-600">
                Stay tuned for more updates and exciting features.
              </p>
              <p className='text-2xl font-bold mt-4 flex flex-col justify-center items-center text-purple-500'><span>CountDown</span><MyTimer expiryTimestamp={1737051600000} /></p>
            </>
          )}
        </div>
        {!loading && (
          <div className="mt-6 flex justify-center">
            <Button
              type="primary"
              onClick={handleOk}
              className="bg-green-600 text-white px-6 py-2 rounded-lg hover:bg-green-700"
            >
              Got it!
            </Button>
          </div>
        )}
      </Modal>

        <Routes>
          <Route path='/' element={<Homepage />} />
          <Route path='/dashboard' element={<Dashboard />} />
          <Route path='/team' element={<Teams />} />
          <Route path='/rewards' element={<Rewards />} />
          <Route path='/matrix' element={<BinaryTree />} />
          <Route path='/yellow' element={<Admin />} />
          <Route path='/radius' element={<Red />} />
          <Route path='/virtus' element={<Virtus />} />
          <Route path='/downline' element={<Downline />} />
        </Routes>
      </div>
    </body>
    </AppState.Provider>
  );
}

export default App;
export {AppState};
